import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'defaultText' })
export class TextDefaultPipe implements PipeTransform {
  transform(value: unknown, replaced: string): unknown {
    if (!value || !(value as string).trim()) {
      return replaced || '-';
    }

    return value;
  }
}
